// ScrollTriggerInView.ts
import { ScrollTrigger } from '$utils/gsap.svelte';

/**
 * Creates a ScrollTrigger instance that triggers a callback function when the specified element is in view.
 * @param node - The HTML element to track for visibility changes.
 * @param onInView - The callback function to execute when the element is in view.
 * @returns An object with a `destroy` method that can be called to clean up the ScrollTrigger instance.
 */
export function ScrollTriggerInView<T extends HTMLElement>(
	node: HTMLElement | HTMLImageElement,
	onInView: (el: T) => void
) {
	const st = ScrollTrigger.create({
		trigger: node,
		limitCallbacks: true,
		once: true,
		onEnter: () => {
			onInView(node);
		},
		// You can also use other properties like start, end, markers, etc., as needed
	});

	// Return a cleanup function if necessary
	return {
		/**
		 * Cleans up the ScrollTrigger instance.
		 */
		destroy() {
			st.kill({
				revert: true,
			});
		},
	};
}
